import { render } from "./LoadingWheel.vue?vue&type=template&id=39734cfc&scoped=true"
import script from "./LoadingWheel.vue?vue&type=script&lang=js"
export * from "./LoadingWheel.vue?vue&type=script&lang=js"

import "./LoadingWheel.vue?vue&type=style&index=0&id=39734cfc&scoped=true&lang=css"

import exportComponent from "/home/heather/Documents/Work/Soldel/pwa2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39734cfc"]])

export default __exports__